import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const stats = [
  { icon: 'ri-user-line', value: '500万+', label: '月活跃用户' },
  { icon: 'ri-article-line', value: '10万+', label: '累计爆料' },
  { icon: 'ri-thumb-up-line', value: '98%', label: '用户好评率' },
  { icon: 'ri-team-line', value: '200+', label: '专业编辑团队' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('感谢您的留言，我们会尽快回复！');
      return;
    }

    setFormStatus('submitting');
    setFormMessage('');

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9phaeub4qjhggaepuc0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = (parsed?.meta as Record<string, unknown>)?.message as string
          || (parsed?.meta as Record<string, unknown>)?.detail as string
          || parsed?.message as string
          || responseText
          || '提交失败';
        if (typeof serverMsg === 'string' && serverMsg.includes('spam')) {
          setFormStatus('success');
          setFormMessage('感谢您的留言，我们会尽快回复！');
          form.reset();
        } else {
          setFormStatus('error');
          setFormMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试');
    } finally {
      if (formStatus !== 'error') {
        setTimeout(() => setFormStatus('idle'), 5000);
      }
    }
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于17吃瓜',
    description: '17吃瓜是您获取最新娱乐八卦、明星爆料、热点事件的首选平台。',
    url: 'https://17chigua.com/about',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '17吃瓜的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容来自专业编辑团队的全网采集和原创撰写，同时也有用户投稿和爆料。所有内容均经过严格的审核流程，确保真实性和时效性。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向17吃瓜提供爆料线索？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过页面底部的联系表单、发送邮件至 contact@17chigua.com 或在社交平台私信我们提供爆料线索。我们会对爆料人信息严格保密。',
        },
      },
      {
        '@type': 'Question',
        name: '17吃瓜的更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们实行全天候滚动更新机制，编辑团队7x24小时不间断追踪热点事件，确保您随时打开都能看到最新的爆料内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与我们进行商业合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '商业合作请发送邮件至 contact@17chigua.com，我们的商务团队会在1-2个工作日内与您联系，沟通具体合作方案。',
        },
      },
      {
        '@type': 'Question',
        name: '发现不实信息如何举报？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们高度重视内容真实性。如发现任何不实信息，请立即通过联系表单或邮件向我们举报，我们会在核实后第一时间处理。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 17吃瓜"
        description="17吃瓜是您获取最新娱乐八卦、明星爆料、热点事件的首选平台。了解我们的品牌故事、团队口碑和联系方式。"
        keywords="17吃瓜,关于我们,娱乐爆料平台,品牌介绍,联系方式"
        canonicalUrl="https://17chigua.com/about"
        schema={[aboutSchema, faqSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-16">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            {/* Hero */}
            <section className="text-center py-10 md:py-16">
              <h1 className="text-4xl md:text-5xl font-bold text-foreground-950 mb-5">关于17吃瓜</h1>
              <p className="text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                我们致力于打造华人圈最专业的娱乐资讯平台，让每一个热爱吃瓜的你，都能第一时间获取最新、最全、最真实的娱乐爆料。
              </p>
            </section>

            {/* Stats */}
            <section className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-3">
                    <i className={`${stat.icon} text-xl text-accent-600`}></i>
                  </div>
                  <div className="text-2xl font-bold text-foreground-950">{stat.value}</div>
                  <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </section>

            {/* Brand Story */}
            <section className="mb-16">
              <h2 className="text-2xl font-bold text-foreground-950 mb-6">品牌故事</h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="space-y-4 text-foreground-700 leading-relaxed">
                  <p>
                    17吃瓜诞生于2020年，由一群热爱娱乐八卦的资深媒体人共同创立。我们深知，在这个信息爆炸的时代，人们需要的不仅仅是碎片化的资讯，更是经过专业筛选和深度加工的优质内容。
                  </p>
                  <p>
                    我们的团队由超过200名专业编辑和行业记者组成，覆盖影视、音乐、综艺、网红、社会热点等多个领域。我们7x24小时不间断追踪热点事件，确保您随时打开17吃瓜，都能看到最新鲜的爆料。
                  </p>
                  <p>
                    五年来，17吃瓜已经发展成为华人圈最具影响力的娱乐资讯平台之一，月活跃用户超过500万。我们始终坚持"快、准、深"的内容理念，为亿万吃瓜群众提供最优质的娱乐资讯服务。
                  </p>
                </div>
                <div className="rounded-xl overflow-hidden h-72 lg:h-auto">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20media%20newsroom%20with%20editorial%20team%20working%20at%20desks%20with%20multiple%20screens%2C%20warm%20office%20lighting%2C%20collaborative%20workspace%2C%20professional%20creative%20environment%2C%20clean%20minimalist%20office%20design&width=800&height=600&seq=about-brand&orientation=landscape"
                    alt="17吃瓜编辑团队"
                    className="w-full h-full object-cover"
                    title="17吃瓜 - 专业编辑团队"
                  />
                </div>
              </div>
            </section>

            {/* Reputation */}
            <section className="mb-16">
              <h2 className="text-2xl font-bold text-foreground-950 mb-6">行业口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    quote: '17吃瓜在娱乐资讯的及时性和准确性上做得很出色，是行业内值得学习的标杆。',
                    author: '某知名媒体主编',
                    role: '媒体行业从业15年',
                  },
                  {
                    quote: '作为内容创作者，17吃瓜的选题视角和内容深度给了我很多灵感。',
                    author: '头部自媒体博主',
                    role: '全网粉丝800万+',
                  },
                  {
                    quote: '我们品牌选择与17吃瓜合作，看中的就是他们对内容质量的坚持和对用户的责任心。',
                    author: '某品牌市场总监',
                    role: '多次合作品牌方',
                  },
                ].map((testimonial, idx) => (
                  <div key={idx} className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                    <div className="flex items-center gap-1 mb-4">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-foreground-700 leading-relaxed mb-4 italic">
                      "{testimonial.quote}"
                    </p>
                    <div className="border-t border-background-200/70 pt-4">
                      <div className="font-semibold text-foreground-900 text-sm">{testimonial.author}</div>
                      <div className="text-xs text-foreground-500 mt-0.5">{testimonial.role}</div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* FAQ */}
            <section className="mb-16">
              <h2 className="text-2xl font-bold text-foreground-950 mb-6">常见问题</h2>
              <div className="space-y-3">
                {[
                  { q: '17吃瓜的内容来源是什么？', a: '我们的内容来自专业编辑团队的全网采集和原创撰写，同时也有用户投稿和爆料。所有内容均经过严格的审核流程，确保真实性和时效性。' },
                  { q: '如何向17吃瓜提供爆料线索？', a: '您可以通过页面底部的联系表单、发送邮件至 contact@17chigua.com 或在社交平台私信我们提供爆料线索。我们会对爆料人信息严格保密。' },
                  { q: '17吃瓜的更新频率是怎样的？', a: '我们实行全天候滚动更新机制，编辑团队7x24小时不间断追踪热点事件，确保您随时打开都能看到最新的爆料内容。' },
                  { q: '如何与我们进行商业合作？', a: '商业合作请发送邮件至 contact@17chigua.com，我们的商务团队会在1-2个工作日内与您联系，沟通具体合作方案。' },
                  { q: '发现不实信息如何举报？', a: '我们高度重视内容真实性。如发现任何不实信息，请立即通过联系表单或邮件向我们举报，我们会在核实后第一时间处理。' },
                ].map((faq, idx) => (
                  <details key={idx} className="group rounded-lg bg-background-50 border border-background-200/70">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <span className="text-sm font-semibold text-foreground-900">{faq.q}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg"></i>
                    </summary>
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section id="contact">
              <h2 className="text-2xl font-bold text-foreground-950 mb-6">联系我们</h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">电子邮箱</h3>
                      <p className="text-sm text-foreground-600 mt-1">contact@17chigua.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">联系电话</h3>
                      <p className="text-sm text-foreground-600 mt-1">010-8888-6666</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">公司地址</h3>
                      <p className="text-sm text-foreground-600 mt-1">北京市朝阳区光华路88号国贸大厦18层</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground-900 text-sm">工作时间</h3>
                      <p className="text-sm text-foreground-600 mt-1">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                <div className="rounded-lg bg-background-50 border border-background-200/70 p-6">
                  <h3 className="font-semibold text-foreground-950 mb-5">发送消息</h3>
                  <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          required
                          placeholder="您的姓名"
                          className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400"
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          required
                          placeholder="your@email.com"
                          className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400"
                        />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        required
                        placeholder="消息主题"
                        className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400"
                      />
                    </div>
                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                      <textarea
                        id="message"
                        name="message"
                        required
                        rows={4}
                        maxLength={500}
                        placeholder="请输入您要留言的内容（最多500字）"
                        className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 resize-none"
                      ></textarea>
                      <p className="text-xs text-foreground-400 mt-1 text-right">最多500字符</p>
                    </div>
                    <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="absolute opacity-0 pointer-events-none" />
                    <button
                      type="submit"
                      disabled={formStatus === 'submitting'}
                      className="w-full py-3 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-400 text-background-50 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
                    >
                      {formStatus === 'submitting' ? '发送中...' : '发送消息'}
                    </button>

                    {formStatus === 'success' && (
                      <div className="p-3 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700 flex items-center gap-2">
                        <i className="ri-check-line text-green-500"></i>
                        {formMessage}
                      </div>
                    )}
                    {formStatus === 'error' && (
                      <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700 flex items-center gap-2">
                        <i className="ri-error-warning-line text-red-500"></i>
                        {formMessage}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}